import { defineComponent as _defineComponent } from 'vue'
import WalletTransactionsListing from 'ah-wallets/src/components/WalletTransactionsListing.vue';
import { shortWalletScheduledTransactionsTableFields } from 'ah-trades/src/models/transactionsTableFields';
import { ScheduleState } from 'ah-api-gateways';
import WalletIcon from '@/app/icons/svgs/WalletIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentsDashboardWidget',
  setup(__props) {

const scheduledTransactionFilters = {
  scheduleState: [ScheduleState.PENDING_CONFIRMATION, ScheduleState.READY, ScheduleState.SUBMITTED],
};

return { __sfc: true,scheduledTransactionFilters, WalletTransactionsListing, shortWalletScheduledTransactionsTableFields, WalletIcon }
}

})